// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import SearchController from "./search_controller"
application.register("search", SearchController)

import AdminTableController from "./admin_table_controller"
application.register("admin-table", AdminTableController)

import FormToggleController from "./form_toggle_controller"
application.register("form-toggle", FormToggleController)

import CopyUrlController from "./copy_url_controller"
application.register("copy-url", CopyUrlController)

import RightColumnToggleController from "./right_column_toggle_controller"
application.register("right-column-toggle", RightColumnToggleController)

import SlugInputController from "./slug_input_controller"
application.register("slug-input", SlugInputController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import ToggleFocusController from "./toggle_focus_controller"
application.register("toggle-focus", ToggleFocusController)

import DaySelectorController from "./day_selector_controller"
application.register("day-selector", DaySelectorController)
